import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import '../styles/Booking.css';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';
import { resetUserState } from '../redux/users/reducer';

const timeSlots = [
  '8:00 AM',
  '8:30 AM',
  '11:00 AM',
  '11:30 AM',
  '12:00 PM',
  '12:30 PM',
  '1:00 PM',
  '1:30 PM',
  '2:00 PM',
  '2:30 PM',
  '3:00 PM',
  '3:30 PM',
  '4:00 PM',
  '4:30 PM',
];

const teams = {
  HI_KICK: 'Hi Kick',
  TRINITY: 'Trinity',
  SAVAGE_WOLVES: 'Savage Wolves',
  LION: 'Lion',
  SOOJOKGU: 'SOOJOKGU',
  LOVELYZ: 'Lovelyz',
  CONTROL: 'Control',
  MFA: 'M.F A',
  MFB: 'M.F B',
  UBC: 'UBC',
  LABSTERS: 'Labsters',
  WCLE: 'Tigerwoods',
  ACCOUNTING: 'Accounting',
  SALES: 'Hunters',
};

const currentWeekStart = dayjs().startOf('week').add(1, 'day');
const maxWeekStart = currentWeekStart.add(8, 'week');

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function Booking() {
  const [open, setOpen] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState('');
  const [category, setCategory] = useState('');
  const [homeTeam, setHomeTeam] = useState('');
  const [awayTeam, setAwayTeam] = useState('');
  const [startOfWeek, setStartOfWeek] = useState(
    dayjs().startOf('week').add(1, 'day')
  );
  const [bookedSlots, setBookedSlots] = useState(null);
  const [pageRefreshed, setPageRefreshed] = useState(false);
  //prettier-ignore
  /** @type {[ 'row' | 'column', (value: 'row' | 'column') => void ]} */

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleOpen = (slotDate) => {
    setSelectedSlot(slotDate);
    setOpen(true);
  };

  const handleClose = () => {
    setCategory('');
    setHomeTeam('');
    setAwayTeam('');
    setOpen(false);
  };

  const handleChange = (event) => {
    setCategory(event.target.value);
  };

  const handleHomeTeam = (event) => {
    setHomeTeam(event.target.value);
  };

  const handleAwayTeam = (event) => {
    setAwayTeam(event.target.value);
  };

  const user = useSelector((state) => state.users.user);

  const isLoggedIn =
    useSelector((state) => state.users.isLoggedIn) &&
    localStorage.getItem('token') !== null;

  const findWhoBookedTheSlot = (day, time) => {
    const dayTime = parseDateTime(day, time);
    const theSlot = bookedSlots.find((slot) => slot.id === dayTime);

    if (window.innerWidth >= 600) {
      return (
        <div className="slot-button">
          <p>
            {(theSlot.userFirstName.includes(' ')
              ? theSlot.userFirstName.slice(
                  0,
                  theSlot.userFirstName.indexOf(' ')
                )
              : theSlot.userFirstName) +
              ' ' +
              theSlot.userLastName.slice(0, 1)}
          </p>
          <p>{` for ${theSlot.category} `}</p>
          <p>
            {theSlot.category === 'PRACTICE' &&
              teams[theSlot.homeTeam] &&
              `Team: ${teams[theSlot.homeTeam]}`}
          </p>
          <p>
            {theSlot.category === 'GAME' &&
              teams[theSlot.homeTeam] + ' VS. ' + teams[theSlot.awayTeam]}
          </p>
        </div>
      );
    } else {
      return (
        <div className="slot-button">
          <p>
            {(theSlot.userFirstName.includes(' ')
              ? theSlot.userFirstName.slice(
                  0,
                  theSlot.userFirstName.indexOf(' ')
                )
              : theSlot.userFirstName) +
              ' ' +
              theSlot.userLastName.slice(0, 1) +
              ` for ${theSlot.category} `}
          </p>
          <p>
            {theSlot.category === 'PRACTICE' &&
              teams[theSlot.homeTeam] &&
              `Team: ${teams[theSlot.homeTeam]}`}
          </p>
          <p>
            {theSlot.category === 'GAME' &&
              teams[theSlot.homeTeam] + ' VS. ' + teams[theSlot.awayTeam]}
          </p>
        </div>
      );
    }
  };

  useEffect(() => {
    const fetchBookedSlots = async () => {
      try {
        const response = await fetch(
          `https://api.innofitness.ca/bookings/slots?start=${startOfWeek.format('YYYY-MM-DD')}`,
          {
            method: 'GET',
            headers: {
              access: localStorage.getItem('token'),
            },
          }
        );
        const data = await response.json();
        setBookedSlots(data);
      } catch (error) {
        if (error.message.includes('access token expired')) {
          localStorage.removeItem('token');
          dispatch(resetUserState());
          navigate('/');
        } else {
          window.alert('Error fetching slots');
        }
      }
    };

    fetchBookedSlots();
  }, []);

  useEffect(() => {
    const fetchBookedSlots = async () => {
      try {
        const response = await fetch(
          `https://api.innofitness.ca/bookings/slots?start=${startOfWeek.format('YYYY-MM-DD')}`,
          {
            method: 'GET',
            headers: {
              access: localStorage.getItem('token'),
            },
          }
        );
        const data = await response.json();
        setBookedSlots(data);
      } catch (error) {
        if (error.message.includes('access token expired')) {
          localStorage.removeItem('token');
          dispatch(resetUserState());
          navigate('/');
        } else {
          console.error('Error fetching slots');
        }
      }
    };

    fetchBookedSlots();
  }, [pageRefreshed]);

  useEffect(() => {
    if (category === 'PRACTICE') {
      setHomeTeam(user.jokguTeam ?? null);
    }
  }, [category, user.jokguTeam]);

  const handleBooking = async (selectedSlot, category, homeTeam, awayTeam) => {
    try {
      const response = await fetch('https://api.innofitness.ca/bookings', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          access: localStorage.getItem('token'),
        },
        // body: formattedDateTime,
        body: JSON.stringify({
          id: selectedSlot,
          userFirstName: user.firstName,
          userLastName: user.lastName,
          category: category,
          homeTeam: homeTeam || null,
          awayTeam: awayTeam || null,
        }),
      });

      if (response.ok) {
        window.alert('Booking successful!');
        window.location.reload();
      }
    } catch (error) {
      if (error.message.includes('access token expired')) {
        localStorage.removeItem('token');
        dispatch(resetUserState());
        navigate('/');
      } else {
        console.error('Error booking slot');
      }
    }
  };

  const parseDateTime = (day, time) => {
    const timeParts = time.split(' ');
    const [hours, minutes] = timeParts[0].split(':');
    let hoursIn24 = parseInt(hours, 10);

    if (timeParts[1] === 'PM' && hoursIn24 !== 12) {
      hoursIn24 += 12;
    } else if (timeParts[1] === 'AM' && hoursIn24 === 12) {
      hoursIn24 = 0;
    }

    const dayString = day.toISOString().slice(2, 10).replace(/-/g, '');
    return dayString + (hoursIn24 < 10 ? '0' + hoursIn24 : hoursIn24) + minutes;
  };

  const isSlotPast = (slotDate) => {
    return moment(slotDate, 'YYMMDDHHmm').isBefore(moment(), 'minute');
  };

  const isSlotBooked = (slotDate) => {
    return bookedSlots.some((slot) => {
      return slot.id == slotDate;
    });
  };

  useEffect(() => {
    if (!user || !isLoggedIn) {
      navigate('/');
    }
  });

  if (!bookedSlots) {
    return (
      <Container
        className="page-container"
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <CircularProgress color="inherit" />
      </Container>
    );
  } else {
    return (
      <Container
        className="page-container"
        sx={{ maxWidth: '1200px', px: 'max(2%, 16px) !important' }}
      >
        <div className="page-title">
          <h1 style={{ textAlign: 'center' }}>Court Booking</h1>
          <Typography variant="h5" align="center" gutterBottom sx={{ mb: 0 }}>
            Weekly Booking Schedule ({startOfWeek.format('MMM DD')} -{' '}
            {startOfWeek.add(4, 'days').format('MMM DD')})
          </Typography>
        </div>
        <Grid container justifyContent="center" spacing={0}>
          {Array.from({ length: 5 }).map((_, dayIndex) => {
            const day = startOfWeek.add(dayIndex, 'day');
            return (
              <Grid
                key={dayIndex}
                size={{ xs: 7, sm: 12 / 5 }}
                sx={{ minWidth: { xs: '250px', sm: '0' } }}
              >
                <Card
                  sx={{
                    py: '16px',
                    boxShadow: 'none',
                  }}
                >
                  <CardContent
                    elevation={0}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'left',
                      padding: { xs: '0', sm: '4px' },
                      gap: '0',
                      '&.MuiCardContent-root:last-child': {
                        paddingBottom: '0',
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      align="center"
                      sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        textWrap: 'nowrap',
                        alignContent: 'center',
                      }}
                    >
                      {day.format('ddd, MMM DD')}
                    </Typography>
                    {timeSlots.map((time) => {
                      return (
                        <Button
                          key={time}
                          variant="contained"
                          color={'success'}
                          onClick={() => {
                            const slotDate = parseDateTime(day, time);
                            handleOpen(slotDate);
                          }}
                          disabled={
                            isSlotPast(parseDateTime(day, time)) ||
                            isSlotBooked(parseDateTime(day, time))
                          }
                          sx={
                            isSlotBooked(parseDateTime(day, time))
                              ? {
                                  marginTop: 8,
                                  color: 'white',
                                  margin: { xs: '2px auto', sm: '5px auto' },
                                  width: '100%',
                                  // height: '49px',
                                  height: {
                                    xs: '40px',
                                    sm: '61px',
                                  },
                                  maxWidth: '500px',
                                  px: '0px',
                                  fontSize: '0.875rem',
                                  letterSpacing: '0px',
                                  textTransform: 'none',
                                }
                              : {
                                  marginTop: 8,
                                  color: 'white',
                                  margin: { xs: '2px auto', sm: '5px auto' },
                                  width: '100%',
                                  // height: '49px',
                                  height: {
                                    xs: '40px',
                                    sm: '61px',
                                  },
                                  maxWidth: '500px',
                                  px: '16px',
                                  fontSize: '0.875rem',
                                }
                          }
                        >
                          {isSlotBooked(parseDateTime(day, time))
                            ? findWhoBookedTheSlot(day, time)
                            : time}
                        </Button>
                      );
                    })}
                    <Modal
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="slot-booking-modal-title"
                      sx={{
                        '& .MuiBox-root': {
                          maxWidth: '95%',
                          mx: 'auto',
                        },
                        '& .MuiBackdrop-root': {
                          backgroundColor: 'rgba(0, 0, 0, 0.2)',
                        },
                      }}
                    >
                      <Box sx={modalStyle}>
                        <div className="slot-booking-modal">
                          <Typography
                            id="slot-booking-modal-title"
                            variant="h5"
                          >
                            {`${moment(selectedSlot, 'YYMMDDHHmm').format('ddd, MMM DD h:mm A')}`}
                          </Typography>
                          <FormControl fullWidth>
                            <InputLabel>Category</InputLabel>
                            <Select
                              value={category}
                              label="Category"
                              onChange={handleChange}
                            >
                              <MenuItem value={'PRACTICE'}>Practice</MenuItem>
                              <MenuItem value={'GAME'}>Game</MenuItem>
                              <MenuItem value={'EVENT'}>Event</MenuItem>
                            </Select>
                          </FormControl>
                          {category === 'PRACTICE' && (
                            <FormControl fullWidth>
                              <InputLabel>Team</InputLabel>
                              <Select
                                value={homeTeam}
                                label="Team"
                                onChange={handleHomeTeam}
                              >
                                <MenuItem key={'private'} value={null}>
                                  (Private Practice)
                                </MenuItem>
                                {Object.entries(teams).map(([key, value]) => (
                                  <MenuItem key={key} value={key}>
                                    {value}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          )}
                          {category === 'GAME' && (
                            <div className="team-selection">
                              <FormControl className="home-team">
                                <InputLabel>Your Team</InputLabel>
                                <Select
                                  value={homeTeam}
                                  label="Your Team"
                                  onChange={handleHomeTeam}
                                >
                                  {Object.entries(teams).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>
                                      {value}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <FormControl className="away-team">
                                <InputLabel>Opponent Team</InputLabel>
                                <Select
                                  value={awayTeam}
                                  label="Opponent Team"
                                  onChange={handleAwayTeam}
                                >
                                  <MenuItem key={'undecided'} value={null}>
                                    (Undecided)
                                  </MenuItem>
                                  {Object.entries(teams).map(([key, value]) => (
                                    <MenuItem key={key} value={key}>
                                      {value}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          )}
                          <Button
                            variant="outlined"
                            color="success"
                            sx={{ width: '150px', margin: '20px auto 0 auto' }}
                            onClick={() => {
                              handleBooking(
                                selectedSlot,
                                category,
                                homeTeam,
                                awayTeam
                              );
                            }}
                          >
                            Book
                          </Button>
                        </div>
                      </Box>
                    </Modal>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
        <Grid
          container
          justifyContent="center"
          spacing={2}
          style={{ marginTop: '20px', marginBottom: '40px' }}
        >
          <Grid>
            <Button
              variant="contained"
              onClick={() => {
                setBookedSlots(null);
                setStartOfWeek(startOfWeek.subtract(7, 'day'));
                setPageRefreshed(!pageRefreshed);
              }}
              disabled={startOfWeek.isSame(currentWeekStart, 'day')}
              sx={{ width: '155px', height: '40px' }}
            >
              Previous Week
            </Button>
          </Grid>
          <Grid>
            <Button
              variant="contained"
              onClick={() => {
                setBookedSlots(null);
                setStartOfWeek(startOfWeek.add(7, 'day'));
                setPageRefreshed(!pageRefreshed);
              }}
              disabled={startOfWeek.isSame(maxWeekStart, 'day')}
              sx={{ width: '155px', height: '40px' }}
            >
              Next Week
            </Button>
          </Grid>
        </Grid>
      </Container>
    );
  }
}
